/* FILE: assets/akf-endpoints.js */
(function (global) {
  const BASE = 'https://stark-chamber-2909.herokuapp.com'; // change to App Proxy later if needed

  const AKF = {
    /** Fetch product JSON from Rails by handle. */
    async fetchProduct(handle) {
      if (!handle) throw new Error('handle required');
      const url = `${BASE}/products/${encodeURIComponent(handle)}.js`; // .js returns JSON
      AKF.BASE = BASE;
      const res = await fetch(url, {
        headers: { 'Accept': 'application/json' },
        credentials: 'omit'
      });
      if (!res.ok) {
        const body = await res.text().catch(() => '');
        throw new Error(`AKF fetch failed ${res.status}: ${body}`);
      }
      return res.json();
    },

    /** Extract handle from /products/<handle>[.ext] URLs. */
    handleFromLocation() {
      const path = location.pathname.replace(/^\/+|\/+$/g, '');
      const parts = path.split('/');
      if (parts[0] === 'products') return (parts[1] || '').split('.').shift();
      return parts.pop() || '';
    }
  };

  global.AKF = AKF;
})(window);

/* --- HOW TO WIRE IT (do this outside this file) ---------------------------

1) FILE: layout/theme.liquid
   Add this just before </head>:

   <script src="{{ 'akf-endpoints.js' | asset_url }}" defer></script>

2) In any page/section where you previously did:
     fetch(`/products/${encodeURIComponent(handle)}.js`).then(r => r.json()).then(...)
   replace with:
     const data = await AKF.fetchProduct(handle);

   Example drop-in:
   <script>
   document.addEventListener('DOMContentLoaded', async () => {
     try {
       const handle = AKF.handleFromLocation(); // or your existing handle logic
       const data = await AKF.fetchProduct(handle);
       // ... render with `data` ...
     } catch (e) { console.error(e); }
   });
   </script>

--------------------------------------------------------------------------- */
